// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kzDS","col":"styles_col__13kye","actions":"styles_actions__38k1I","conflict":"styles_conflict__33J8J"};